import React from 'react'
import PropTypes from 'prop-types'

import { TableCell } from '../../../Table'


const DeviceName = ({ row }) => {
  const { firstName, lastName } = row.original || {}
  const nameExists = firstName && lastName

  return (
    <TableCell data-testid="users-name">{nameExists ? `${firstName} ${lastName}` : ''}</TableCell>
  )
}

DeviceName.propTypes = {
  row: PropTypes.object.isRequired
}

export default DeviceName
